import type {
  AutomationAction,
  AutomationCondition,
  AutomationTrigger,
} from '../types/automation'

export const AUTOMATION_BOARD_CAPS = {
  triggers: 2,
  then: 2,
  else: 2,
  constraints: 2,
} as const

export type AutomationGraphRuleInput = {
  triggers: AutomationTrigger[]
  if?: AutomationCondition | null
  then: AutomationAction[]
  else?: AutomationAction[] | null
}

export const validateAutomationGraphShape = ({
  triggers,
  if: ifCondition,
  then,
  else: elseActions,
}: AutomationGraphRuleInput): string | null => {
  if (triggers.length === 0) return 'Add at least one WHEN trigger.'
  if (triggers.length > AUTOMATION_BOARD_CAPS.triggers) return 'WHEN can hold at most two triggers.'
  if (then.length === 0) return 'Add at least one THEN action.'
  if (then.length > AUTOMATION_BOARD_CAPS.then) return 'THEN can hold at most two actions.'
  if ((elseActions?.length ?? 0) > AUTOMATION_BOARD_CAPS.else) return 'ELSE can hold at most two actions.'
  if ((ifCondition?.clauses.length ?? 0) > AUTOMATION_BOARD_CAPS.constraints) return 'BUT can hold at most two constraints.'
  if ((ifCondition?.clauses.length ?? 0) === 0 && (elseActions?.length ?? 0) > 0) {
    return 'Add a BUT constraint before adding ELSE actions.'
  }
  return null
}
